import { render, staticRenderFns } from "./Consultation.vue?vue&type=template&id=662ea579&scoped=true"
import script from "./Consultation.vue?vue&type=script&lang=js"
export * from "./Consultation.vue?vue&type=script&lang=js"
import style0 from "./Consultation.vue?vue&type=style&index=0&id=662ea579&prod&scoped=true&lang=scss"
import style1 from "./Consultation.vue?vue&type=style&index=1&id=662ea579&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662ea579",
  null
  
)

export default component.exports